import * as t from "io-ts";
import {LocationMetaRelationshipCodec} from "./location-meta-relationship";
import {LocationMetaShiftCodec} from "./location-meta-shift";
import {LocationMetaGeofenceEventCodec} from "./location-meta-geofence-event";
import {LocationMetaWorkCodec} from "./location-meta-work";
import {LocationMetaPossibleDestinationCodec} from "./location-meta-possible-destination";
import {LocationMetaContentsCodec} from "./location-meta-contents";
import {
  LocationMetaActivityCodec,
  locationActivityState,
  type LocationMetaActivity,
  type LocationMetaActivityState,
} from "./location-meta-activity";
import {LocationMetaDestinationRecommendationCodec} from "./location-meta-destination-recommendation";
import {LocationMetaOriginCodec} from "./location-meta-origin";

export const LocationMetaCodec = t.intersection([
  t.union([
    t.type({activity: LocationMetaActivityCodec}),
    t.type({inShift: t.boolean, onSite: t.boolean, status: t.string}),
  ]),
  t.partial({
    inShift: t.boolean,
    onSite: t.boolean,
    status: t.string,
    contents: LocationMetaContentsCodec,
    activity: LocationMetaActivityCodec,
    destination: LocationMetaDestinationRecommendationCodec,
    lastSyncDttm: t.number,
    relationships: t.array(LocationMetaRelationshipCodec),
    shift: LocationMetaShiftCodec,
    geofenceEvent: LocationMetaGeofenceEventCodec,
    work: LocationMetaWorkCodec,
    origin: LocationMetaOriginCodec,
    possibleDestinations: t.record(t.string, LocationMetaPossibleDestinationCodec),
  }),
]);

export const LocationMetaArrayCodec = t.array(LocationMetaCodec);

export type LocationMeta = t.TypeOf<typeof LocationMetaCodec> & {
  /** @deprecated Read activity.inShift through getLocationMetaActivity. */
  inShift?: boolean;
  /** @deprecated Read activity.onSite through getLocationMetaActivity. */
  onSite?: boolean;
  /** @deprecated Read activity.status through getLocationMetaActivity. */
  status?: string;
};

/** Canonical facts take precedence. Flat fields are a compatibility bridge for older servers. */
export function getLocationMetaActivity(
  meta?: LocationMeta
): (LocationMetaActivity & {state: LocationMetaActivityState}) | undefined {
  if (!meta) return undefined;
  if (meta.activity) return {...meta.activity, state: locationActivityState(meta.activity.status)};
  const status = meta.status ?? "UNKNOWN";
  return {inShift: meta.inShift ?? false, onSite: meta.onSite ?? false, status, state: locationActivityState(status)};
}
